import { useNavigate } from 'react-router-dom'
import { deleteById } from '../../api/common';
import Modal from "../commons/Modal";
import { Button } from 'react-bootstrap';
import { CancelarProgramacion } from '../Programaciones/CancelarPorgramacion';
import { useAuth } from '../../hooks/useAuth';
import EditarProgramacionCalendario from './EditarProgramacionCalendario';
import { useEffect, useState } from 'react';
import { Alertassw } from '../Alertas/Alertassw';
import Swal from 'sweetalert2';
import { LoadingModal } from '../commons/LoadingSpiner';

export function DetailEvent ({event, isOpen, setIsOpen, refresh, setRefresh }) {
    const {title, end, start, createdBy, descripcion, responsable, zonaCliente, numeroEquipos, type, otNumeroOrden, id, estado, puedeEditar} = event;

    const [viewRepogramar, setViewRepogramar]=useState(false)
    const [modalSpinner, setModalSpinner]=useState(false)
    const navigate = useNavigate();
    const {userData}=useAuth()

    const handleDetalle = (id) => {
        navigate(`/Programacion/${id}?&task=finalizar`, { replace: true })
    }

    useEffect(()=>{
        setViewRepogramar(false)
    },[isOpen])

    const handleReprogramarExito = () => {
        setRefresh(prev => !prev);
        setViewRepogramar(false);
        setIsOpen(false);
    };

    return(
        <>
        <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
            {viewRepogramar
              ? <EditarProgramacionCalendario
                  evento={event}
                  onExito={handleReprogramarExito}
                  onCancelar={() => setViewRepogramar(false)}
                />
              :
            <div className="detail-event-calendar">
                <h3 className='calendar-detail-title'>{title.toUpperCase()}</h3>
                {createdBy && <div className='calendar-detail-list-container'><h6>Creado por:</h6><h6>{createdBy}</h6></div>}
                {type === 'Programación' ?
                                <>
                                <div className='calendar-detail-list-container'><h6>Estado: </h6> <h6>{estado}</h6></div>
                                <div className='calendar-detail-list-container'><h6>Responsable: </h6> <h6>{responsable}</h6></div>
                                <div className='calendar-detail-list-container'><h6>Fecha Inicio: </h6> <h6>{new Date(start).toLocaleString()}</h6></div>
                                <div className='calendar-detail-list-container'><h6>Fecha Cierre: </h6> <h6>{new Date(end).toLocaleString()}</h6></div>
                                <div className='calendar-detail-list-container'><h6>Ciudad: </h6><h6>{zonaCliente}</h6></div>
                                <div className='calendar-detail-list-container'><h6>Numero Equipos: </h6><h6>{numeroEquipos}</h6></div>
                                </>
                                :
                                <div className='calendar-detail-list-container'><h6>Fecha:</h6><h6>{new Date(start).toLocaleString()}</h6></div>
                }
                {descripcion && descripcion.length > 0 && <h5 className='calendar-detail-descripcion'>{descripcion}</h5>}
                {puedeEditar && (
                <div className='button-controller'>
                    {
                        type === 'Programación' && estado !== 'FINALIZADO' ?
                            (
                                <>
                                    <Button variant='primary' size='lg' className='me-2' onClick={() => handleDetalle(id)}>Ver Detalle</Button>
                                    <Button variant='warning' size='lg' className='me-2' onClick={() => setViewRepogramar(true)}>Reprogramar</Button>
                                    <Button variant='danger' size='lg' className='me-2' onClick={() => CancelarProgramacion(id, userData, setRefresh, refresh, setIsOpen, setModalSpinner)}>Cancelar</Button>
                                </>
                            ) : null
                    }
                </div>
                )}
            </div>
            }
        </Modal>
        <LoadingModal show={modalSpinner} text="Guardando cambios, por favor espere..."/>
        </>
    )
}